var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',[_c('v-ons-tabbar',{attrs:{"swipeable":"","position":"auto","tabs":_vm.tabs,"visible":true,"index":_vm.activeIndex},on:{"update:index":function($event){_vm.activeIndex=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }